// OPT-203: the whole redirect decision, pure so it can be tested per group.
// Returns the path to redirect to, or null to proceed.
// OPT-310: having no marketplace account sends no one anywhere; onboarding is
// a prompt (ConnectFirstPrompt), not a gate.
export function routeFor(to, { signedIn, isAdmin, hasAppAccess }) {
  const matched = to.matched || [];
  if (!matched.some((r) => r.meta && r.meta.requiresAuth)) return null;
  if (!signedIn) return "/login";
  const allowWithoutGroup = matched.some((r) => r.meta && r.meta.allowWithoutGroup);
  if (!hasAppAccess && !allowWithoutGroup) return "/account-not-ready";
  if (hasAppAccess && to.name === "AccountNotReady") return "/";
  if (to.meta && to.meta.requiresAdmin && !isAdmin) return "/";
  return null;
}
